import { useMediaQuery } from '@material-ui/core'
import ErrorLine from 'components/ErrorLine'
import Footer from 'components/Footer/Footer'
import Button from 'components/CustomButtons/Button.js'
import HarmonizeHeader from 'components/Header/HarmonizeHeader'
import { getNFT } from 'controllers/NFTController'
import { getMessage } from 'controllers/SocialServiceController'
import { listenForAccountsChange } from 'eth/ethUtils'
import { getHarmonizeContract } from 'eth/ethUtils'
import { ethEnabled } from 'eth/ethUtils'
import { getETHRate } from 'eth/ethUtils'
import { listenForChainChange } from 'eth/ethUtils'
import { getAccountBalanceEth } from 'eth/ethUtils'
import { getOptionsIsRunning } from 'eth/tokenUtils'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { updateNFT } from 'redux/actions/nftActions'
import { setNFTMessage } from 'redux/actions/nftActions'
import { resetNFT } from 'redux/actions/nftActions'
import { displayError } from 'util/screenUtils'
import { isVeryNarrow } from 'util/screenUtils'
import { getLocalPrice } from 'eth/ethUtils'
import DisplayNFTInfo from 'components/nft/DisplayNFTInfo'
import { isOwner } from 'eth/ethUtils'
import { getTokenPrice } from 'eth/ethUtils'
import { store } from 'index'
import { getEthFromGwei } from 'eth/tokenUtils'
let harmonizeContract
export default function DisplayNFT() {
    const { tokenId } = useParams()
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const dispatch = useDispatch()
    const [currentAccount, setCurrentAccount] = useState()
    const [accountBalance, setAccountBalance] = useState()
    const { name, price } = useSelector(state => state.nfts)
    const { currency, showMintingDefaults } = useSelector(
        (state) => state.settings
    )

    const [ethInCurrency, setEthInCurrency] = useState(0)
    const [nftOwner, setNftOwner] = useState(undefined)
    const [error, setError] = useState()
    const [contractIsRunning, setContractIsRunning] = useState(undefined)
    const history = useHistory()
    const displayManage = () => {
        if (nftOwner) {
            return (
                <Button
                    color="success"
                    title='Go back'
                    style={{ cursor: 'pointer' }}
                    onClick={() => history.push(`/ManageNFT/${tokenId}`)}>
                    Manage this NFT
                </Button>
            )
        }

    }
    const displayPrice = () => {

            return (
                <div style={{
                    display: 'flex', width: '50vw', flexDirection: 'column',
                    marginLeft: 'auto', marginRight: 'auto'
                }}>

                    {price === 0 ? <h4 style={{ textAlign: 'center', fontStyle: 'italic' }}>Not for sale</h4> :
                        <div style={{
                            display: 'flex', flexDirection: 'column',
                            justifyContent: 'center', textAlign: 'center'
                        }}>

                            <h4>Sale Price</h4>
                            {getLocalPrice(price, ethInCurrency, currency)}
                            {!nftOwner?<Button
                                color="info"
                                title='Go back'
                                style={{ cursor: 'pointer' }}
                                onClick={() => history.push(`/PurchaseNFT/${tokenId}`)}>
                                Buy this NFT
                            </Button>:null}
                        </div>}
                </div>
            )
        
    }
    const displayMain = () => {
        return (
            <>
                <HarmonizeHeader />

                <ErrorLine error={error} />
                <div style={{
                    display: 'flex', flexDirection: 'column',
                    width: '90vw', marginLeft: 'auto', marginRight: 'auto'
                }}>
                    <h4 style={{ textAlign: 'center' }}>NFT for {name}</h4>
                    <DisplayNFTInfo tokenId={tokenId} currentAccount={currentAccount}
                        accountBalance={accountBalance} />
                    {displayPrice()}
                    {displayManage()}
                    <Button
                        color="info"
                        title='Go back'
                        style={{ cursor: 'pointer' }}
                        onClick={() => history.goBack()}>
                        Close
                    </Button>

                </div>
                <Footer />
            </>
        )
    }

    const checkValidMinting = () => {
        if (contractIsRunning === false) {
            setError(`Harmonize contract is not running`)
        }
    }
    const getOptions = () => {
        if (harmonizeContract) {
            harmonizeContract.methods
                .options()
                .call()
                .then((opts) => {
                    setContractIsRunning(getOptionsIsRunning(opts))
                    checkValidMinting()
                })
        }
    }
    const setupEth = async () => {
        try {
            console.log('DisplayNFT setupEth')
            harmonizeContract = getHarmonizeContract()
            const ethAccount = await ethEnabled()
            console.log(`getAccountAndAsset ${ethAccount}`)
            setCurrentAccount(ethAccount)
            if (ethAccount) {
                setCurrentAccount(ethAccount)
                const balance = await getAccountBalanceEth()
                setAccountBalance(balance)
                listenForAccountsChange()
                listenForChainChange()
                getOptions()
                const ownsNft = await isOwner(tokenId)
                setNftOwner(ownsNft)
            }
            const rate = await getETHRate(currency)
            setEthInCurrency(rate)
        } catch (error) {
            console.error('setupEth error', error)
            if (error.code === -32002) {
                displayError({
                    message:
                        'There is a Metamask connection request waiting for your response. Please tap the Metamask icon to continue.',
                }, setError)
            } else {
                displayError(error, setError)
            }
        }
    }
    const updatePrice = (value) => {
        const nft = store.getState().nfts
        dispatch(updateNFT({ ...nft, price: value }))
    }
    useEffect(() => {
        const fetchMessage = async () => {
            dispatch(resetNFT())
            try {
                const nft = await getNFT(tokenId)
                if (nft) {
                    console.log('DisplayNFT got existing NFT', nft)
                    const { messageId,price } = nft
                    const priceInEth = getEthFromGwei(price)
                    const updatedNft = { ...nft, price: priceInEth }
                    console.log('...updated', updatedNft)
                    dispatch(updateNFT(updatedNft))
                    const socialServiceMessage = await getMessage(messageId)
                    dispatch(setNFTMessage(socialServiceMessage))
                    const currentPrice = await getTokenPrice(tokenId)
                    updatePrice(currentPrice)
                }
            } catch (error) {
                if (error.status === 404) {
                    displayError({ message: 'This NFT not found in Harmonize' }, setError)
                } else {
                    displayError(error, setError)
                }
            }
            if (!currentAccount) {
                setupEth()
            } else {
                getOptions()
            }
        }

        fetchMessage()

    }, [])
    if (process.env.REACT_APP_MODE == 'development') {
        return displayMain()
    } else {
        return <div onContextMenu={(e) => e.preventDefault()}>{displayMain()}</div>
    }
}